export default __webpack_public_path__ + "static/media/Picture1.dd37b7c6.png";